/* eslint-disable no-multi-assign */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { zendeskChatApiKey } from '../../config';
import { setLiveChatDepartment } from '../../actions/orderActions';

class ZendeskChat extends Component {
  constructor() {
    super();
    this.state = {
      open: true,
    };
  }

  componentDidMount() {
    if (!window.$zopim) {
      this.mockZopimApi();
      this.injectZopimScriptTag();
    }

    window.$zopim(() => {
      window.$zopim.livechat.window.onHide(() => {
        window.$zopim.livechat.window.hide();
        this.setState({ open: false });
      });

      this.updateZopimParams(this.props.open);
    });

    window.addEventListener('message', ({ data, origin, source }) => {
      const department = data && data.department;
      if (
        department &&
        origin === this.props.requestHost &&
        source.origin === this.props.requestHost
      ) {
        this.props.setLiveChatDepartment(department);
      }
    });
  }

  componentDidUpdate(prevProps) {
    const shouldOpen = prevProps.open === false && this.props.open === true;
    if (window.$zopim.livechat) {
      this.updateZopimParams(shouldOpen);
    }
  }

  mockZopimApi() {
    const zopim = (window.$zopim = (zopimFunc) => {
      zopim._.push(zopimFunc);
    });

    zopim.set = (zopimSet) => {
      zopim.set._.push(zopimSet);
    };

    zopim._ = [];
    zopim.set._ = [];
    zopim.t = +new Date();
  }

  injectZopimScriptTag() {
    const scriptTag = (window.$zopim.scriptTag = document.createElement('script'));
    const element = document.getElementsByTagName('script')[0];
    element.classList.add('zopim');

    scriptTag.async = !0;
    scriptTag.setAttribute('charset', 'utf-8');
    scriptTag.src = `//v2.zopim.com/?${zendeskChatApiKey}`;
    scriptTag.type = 'text/javascript';

    element.parentNode.insertBefore(scriptTag, element);
  }

  updateZopimParams(shouldOpen) {
    const {
      firstName,
      email,
      phone,
      orderId,
      contactReason,
      department,
      country,
      open,
    } = this.props;

    // open and  being asked to be closed, close and abort
    if (this.state.open && !open) {
      window.$zopim.livechat.hideAll();
      this.setState({ open: false });
      return;
    }

    window.$zopim.livechat.addTags(contactReason);

    const name = firstName ? `${firstName}${orderId ? ` #${orderId}` : ''}` : undefined;
    if (name) {
      window.$zopim.livechat.set({ name });
    }

    if (phone) {
      window.$zopim.livechat.set({ phone });
    }

    if (email) {
      window.$zopim.livechat.set({ email });
    }

    window.$zopim.livechat.setOnConnected(() => {
      const departmentKey = department || country;

      const zopimDepartment = window.$zopim.livechat.departments.getDepartment(departmentKey);
      if (zopimDepartment && zopimDepartment.status === 'online') {
        window.$zopim.livechat.departments.filter('');
        window.$zopim.livechat.departments.setVisitorDepartment(departmentKey);
        window.$zopim.livechat.theme.reload();
        window.$zopim.livechat.setStatus('online');
      } else {
        window.$zopim.livechat.setStatus('offline');
      }
    });

    // not open and being asked to open
    if (shouldOpen && !this.state.open) {
      window.$zopim.livechat.window.toggle();
      this.setState({ open: true });
    }
  }

  render() {
    return null;
  }
}

ZendeskChat.propTypes = {
  open: PropTypes.bool,
  department: PropTypes.string,
  country: PropTypes.string,
  contactReason: PropTypes.string,
  orderId: PropTypes.string,
  email: PropTypes.string,
  firstName: PropTypes.string,
  phone: PropTypes.string,
  requestHost: PropTypes.string,
  setLiveChatDepartment: PropTypes.func,
};

ZendeskChat.defaultProps = {
  open: false,
  orderId: undefined,
  department: undefined,
  country: undefined,
  contactReason: '',
  email: undefined,
  firstName: undefined,
  phone: undefined,
  requestHost: '',
  setLiveChatDepartment: () => {},
};

const mapStateToProps = ({ order, user, request, config }) => {
  const liveChat = order.help.data && order.help.data.liveChat;
  const countryTld = request.country && request.country.tld;
  const countryName = countryTld && config.countries.find((c) => c.id === countryTld).name;

  return {
    orderId: order.help.id,
    department: liveChat && liveChat.department,
    country: countryName,
    contactReason: liveChat && liveChat.contactReason,
    email: user.email,
    firstName: user.firstName,
    phone: user.phone,
    requestHost: request.host,
  };
};

const mapActionsToProps = (dispatch) => ({
  setLiveChatDepartment: (department) => dispatch(setLiveChatDepartment(department)),
});

export default connect(
  mapStateToProps,
  mapActionsToProps,
)(ZendeskChat);
